import { render, staticRenderFns } from "./StorageLocationDetailsView.vue?vue&type=template&id=4a8a5db6"
import script from "./StorageLocationDetailsView.vue?vue&type=script&lang=js"
export * from "./StorageLocationDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports